// extracted by mini-css-extract-plugin
export var root = "Aikg";
export var rootDate = "ndC+";
export var rootLabel = "bpao";